module.exports = __webpack_public_path__ + "static/media/github.5ee25cf9.svg";